/* eslint-disable camelcase */
export default {
	// 商户号首页开始
	welcome: 'Welcome，',

	home_left_notice: 'Professionalism / Integrity / Excellence',
	todo: 'Todos',
	logout: 'Logout',
	version_switch: 'Switch to New Version',
	// 快捷入口
	merchant_management: 'Funding management',
	merchant_query: 'Funding query',
	merchant_apply: 'Funding apply',
	subject_query: 'Subject query',
	merchant_qualification_management: 'Funding qualification management',
	subject_entry: 'Subject entry',
	merchant_certificate_management: 'Funding Certificate Management',
	certificate_apply: 'Funding Certificate Apply',
	authorization_letter_management: 'Authorization letter management',
	authorization_letter_query: 'Authorization letter query',

	// 待办
	approval_todo: 'Approval todo',
	merchant_apply_waiting_for_approval: 'merchant apply pending for approve',
	merchant_right_change_for_approval: 'merchant right change pending for approve ',
	merchant_info_change_for_approval: 'merchant info change pending for approve ',
	merchant_logout_for_approval: 'merchant logout pending for approve',
	// 统计图
	merchant_account_spending_statistics: 'Merchant account spending statistics',
	proportion_of_merchant: 'Proportion of the total number of merchants by category',

	// 其他
	system_guidelines: 'System Guidelines',
	feedback: 'Ask for feedback',
	financial_system_qa: 'Financial system Q&A',
	wired_finance_1: 'Wired Finance 1',
	purchasing_business_qa: 'Purchasing business Q&A',
	it_system_support: 'IT system support',
	it_hotline: 'IT Hotline - Financial System Support ',
	oa_home: 'OA home',
	gmmp: 'Gmmp',
	look_more: 'See more',
	// 商户号首页结束
	system_name: 'system_name',
	category: 'category',
	configuration_value: 'configuration_value',
	Whether_to_enable: 'Whether_to_enable',
	category_code: 'category_code',
	value_code: 'value_code',
	the_name_of_the_value: 'the_name_of_the_value',
	sort: 'sort',
	remark: 'remark',
	operate: 'operate',
	confirm: 'confirm',
	Cancel: 'cancel',
	Revise: 'revise',
	delete: 'Delete',
	add: 'Add',
	enable: 'Enable',
	rule_type_code: 'rule_type_code',
	rule_type_name: 'rule_type_name',
	configure_encoding: 'configure_encoding',
	configuration_name: 'configuration_name',
	configuration: 'configuration',
	priority: 'priority',
	last_modified_by: 'last_modified_by',
	disabled: 'disabled',
	rule_description: 'rule_description',
	inquire: 'inquire',
	please_enter: 'please enter',
	consultation_feedback: 'Consultation & feedback',
	current_account: 'Current account',
	user_roles: 'Roles',
	permission: 'Permissions',
	edit_or_create: 'Edit or create',
	account_info: 'Account information',
	super_admin_info_edit_title: 'Super Administrator Information Entry/Modification'
};
